import { canTrack } from '@cash-web/shared-util-can-track'

import { useRegion } from '../RegionContext'

export function useCanTrack() {
  const regionCode = useRegion()

  return canTrack(regionCode)
}
